import { CONVERT_FROM_UTC, PARSE_DATE, PARSE_TIME, PARSE_LOCAL_DATETIME } from './dates';

export const PARSE_INSPECTIONS = (inspections, params) => {
    return inspections.map((el, index) => {
        const _seq = (index + 1) + ((params.params['page[number]'] - 1) * params.params['page[size]']);
        const endDateTime = el.attributes.inspection_end_datetime
            ? CONVERT_FROM_UTC(el.attributes.inspection_end_datetime) : null;
        const inspectionStartDatetimeLocal = el.attributes.inspection_start_datetime_local ? PARSE_LOCAL_DATETIME(el.attributes.inspection_start_datetime_local) : '';
        const inspectionEndDatetimeLocal = el.attributes.inspection_end_datetime_local ? PARSE_LOCAL_DATETIME(el.attributes.inspection_end_datetime_local) : '';
        return {
            id: el.id,
            seq: _seq,
            ...el.attributes,
            parsed_local_start_date_time: inspectionStartDatetimeLocal,
            parsed_local_end_date_time: inspectionEndDatetimeLocal,
            inspection_end_datetime: endDateTime
                ? `${PARSE_DATE(endDateTime)} ${PARSE_TIME(endDateTime)}` : null,
            inspection_date: `${PARSE_DATE(el.attributes.inspection_date)}`
        };
    });
};
